import React, { Component } from 'react'
import { SnackbarActions } from 'actionsets'
import { connect } from 'react-redux'
import Button from '@material-ui/core/Button'
import MuiSnackbar from '@material-ui/core/Snackbar'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import { compose } from 'utils'
import withStyles from 'styles'

export class Snackbar extends Component{

  state = {
    visible: false
  }

  constructor(props){
    super(props)
    SnackbarActions.bindActions(this)
  }

  render = () =>
    <MuiSnackbar
      ContentProps={{
        classes:{
          root: this.props.classes.bringToFront
        }
      }}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      open={!!this.props.message}
      autoHideDuration={3000}
      onClose={this.actions.clear}
      message={<span className={this.props.classes.pre} id="message-id">{this.props.message}</span>}
      action={[
        <Button key="undo" color="secondary" size="small" onClick={this.actions.clear}>
          CLOSE
        </Button>,
        <IconButton
          key="close"
          aria-label="Close"
          color="inherit"
          onClick={this.actions.clear}
        >
          <CloseIcon />
        </IconButton>,
      ]}
    />
}

const styles = {
  pre: {
    whiteSpace: 'pre'
  },
  bringToFront: {
    zIndex: 1500
  }
}

export default compose(
  withStyles(styles),
  connect(({snackbar}) => snackbar)
)(Snackbar)